/*
 * Front End logger
 * Copyright 2021 Proposify
 */

( function( global, factory ) {
	/* eslint-disable */
	typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory( ) :
	typeof define === 'function' && define.amd ? define( 'logger',factory ) :
	( global.Logger = factory( ) );
	/* eslint-enable */
}( this, ( function( ) {
	'use strict';

	/*
	===============================================================================
	Class: Logger
	===============================================================================
	*/

	return {
		/**
		 * Set logs
		 */

		_logs: { },

		/**
		 * Set name
		 */

		_name: 'default',

		/**
		 * Set Message
		 */

		_message: '',

		/**
		 * Method: create
		 *
		 * @param {String} aName
		 * @param {String} aMsg
		 *
		 * @return {Object}
		 */

		create: function( aName, aMsg ) {
			var name = aName || 'default',
				msg = aMsg || '',
				data = { };

			this._name = name;
			this._message = msg;

			data[ name ] = this._logs;

			return data;
		},

		/**
		 * Method: set
		 *
		 * @param {String} aKey
		 * @param {Mixed} aValue
		 *
		 * @return {Void}
		 */

		set: function( aKey, aValue ) {
			this._logs[ aKey ] = aValue;
		},

		/**
		 * Method: get
		 *
		 * @param {String} aKey
		 *
		 * @return {String|Mixed}
		 */

		get: function( aKey ) {
			if ( this._logs.hasOwnProperty( aKey ) === false ) {
				return '';
			}

			return this._logs[ aKey ];
		},

		/**
		 * Method:
		 * @param {String} aName
		 *
		 * @return {Object}
		 */

		getLogsByName: function( aName ) {
			var name = aName;

			if ( this._name !== name ) {
				return { };
			}

			return this._logs;
		},

		/**
		 * Method: setMessage
		 *
		 * @param {String} aMsg
		 */

		setMessage: function( aMsg ) {
			var msg = aMsg || '';

			this._message = msg;
		},

		/**
		 * Method: getMessage
		 *
		 * @param {String} aName
		 *
		 * @return {String}
		 */

		getMessage: function( ) {
			return this._message;
		},

		/**
		 * Method: publish
		 *
		 * @param {Object} aDD_LOGS
		 * @param {Object} aData
		 * @param {String} aType
		 */

		publish: function( aDD_LOGS, aData, aType ) {
			var dd_logs = aDD_LOGS || null,
				data = aData || { },
				type = aType || 'info';

			if ( dd_logs === null ) {
				this.clear( );

				return;
			}

			dd_logs.logger.log( this.getMessage( ), data, type );

			this.clear( );
		},

		/**
		 * Method: clear
		 */

		clear: function( ) {
			this._logs = { };
			this._name = 'default';
			this._message = '';
		}
	};
} ) ) );

